module.exports = __webpack_public_path__ + "static/media/SecretPokoro.c897bebc.svg";